'use strict';
import classNames from 'classnames';
import * as T from 'prop-types';
import React from 'react';
import {calendarStates} from '../../../calendar/router';
import {SvgIcons} from '../../../core-components/svg-menu-icons/icons';
import {SvgIcon} from '../../../core-components/svg-menu-icons/SvgIcon';
import {I18nComponent} from '../../../core-utilities/react-i18n/I18nComponent';
import {screenHeight} from '../../../core-utilities/responsive-components/ScreenHeightHOC';
import {formsStates} from '../../../forms/router';
import {personnelStates} from '../../../personnel/router';
import {settingsStates} from '../../../settings/router';
import {NotificationPanelButton} from '../../../system/components/NotificationPanelButton';
import {MenuTimer} from '../../../timers/components/MenuTimer';
import {userStates} from '../../../user/router-config';
import {navStates} from '../../router';
import {Link} from '../Link';


export function BaseMainMenuView(props) {
  const PRODUCT_NAME = 'SwiftProjects';
  const userName = props.modelState.user ? props.modelState.user.displayName : '';
  const organizationName = props.modelState.organization ? props.modelState.organization.name : '';
  // const projectName = props.modelState.project ? props.modelState.project.name : '';
  // const assetName = props.modelState.asset ? props.modelState.asset.name || props.modelState.asset.identifier : '';

  const orgChildLinkClass = classNames('MainMenu__nav', {
    'MainMenu__nav_disabled': !organizationName,
  });

  return (
    <div
      className={classNames('MainMenu', props.className)}
      style={props.heightStyle}
    >
      <div className="MainMenu__header">
        {props.avatar}
        <h1 className="MainMenu__header__title">
          <span className="MainMenu__header__productName">
            {PRODUCT_NAME}
          </span>
          <span className="MainMenu__header__userName">
            {userName}
          </span>
        </h1>
        <i
          className={classNames('MainMenu__header__btn', 'icon', 'ion-ios-arrow-down')}
          title="Show context menu"
          onClick={props.onShowUserMenu}
        />
      </div>

      <div className="MainMenu__content">
        <div>
          <div className="MainMenu__userSection">
            <div className="MainMenu__sectionHeader">
              <span>
                {props.userSectionLabel}
              </span>
            </div>

            {renderLink({
              props: props,
              className: 'MainMenu__nav',
              contentClassName: classNames('MainMenu__nav__content MainMenu__nav__unread', {
                'MainMenu__nav__unread_show': props.unseenPriority,
              }),
              to: userStates.home,
              label: props.userHomeLabel,
              svgIcon: SvgIcons.Home,
            })}

            {renderLink({
              props: props,
              className: 'MainMenu__nav',
              contentClassName: classNames('MainMenu__nav__content MainMenu__nav__unread', {
                'MainMenu__nav__unread_show': props.unseenChat,
              }),
              to: userStates.chat,
              label: props.conversationsLabel,
              svgIcon: SvgIcons.Chat,
            })}

            {renderLink({
              props: props,
              className: 'MainMenu__nav',
              to: userStates.feed,
              label: props.activityFeedLabel,
              svgIcon: SvgIcons.ActivityFeed,
            })}
          </div>

          {renderLink({
            props: props,
            className: 'MainMenu__nav MainMenu__nav_to',
            to: navStates.orgsList,
            label: props.navigateToLabel,
            svgIcon: SvgIcons.NavigateTo,
          })}

          {renderLink({
            props: props,
            className: classNames(orgChildLinkClass, {
              'hide-elem': !props.permissions || !props.permissions.canViewForms,
            }),
            to: formsStates.forms,
            label: props.formsLabel,
            icon: 'icon menu-icon ion-document-text',
          })}

          {renderLink({
            props: props,
            className: orgChildLinkClass,
            to: navStates.projectsList,
            label: props.projectHomeLabel,
            svgIcon: SvgIcons.Project,
          })}

          {renderRecentList(props, orgChildLinkClass, props.latestProjects, props.onSelectProject)}

          {renderLink({
            props: props,
            className: orgChildLinkClass,
            to: navStates.assetsList,
            label: props.assetsHomeLabel,
            svgIcon: SvgIcons.Asset,
          })}

          {renderRecentList(props, orgChildLinkClass, props.latestAssets, props.onSelectAsset)}

          {renderLink({
            props: props,
            className: orgChildLinkClass,
            to: personnelStates.personnelHome,
            label: props.personnelHomeLabel,
            svgIcon: SvgIcons.Personnel,
          })}

          {renderLink({
            props: props,
            className: orgChildLinkClass,
            to: calendarStates.orgCalendar,
            label: props.orgCalendarLabel,
            svgIcon: SvgIcons.Calendar,
          })}
        </div>
      </div>

      <div className="MainMenu__footer">
        <Link
          className={classNames('MainMenu__timer', {
            'hide-elem': !props.menuTimerProps.hasTimers,
          })}
          onClick={props.onCloseMenu}
          to={userStates.home}
          navState={props.navState}
        >
          <MenuTimer
            {...props.menuTimerProps}
          />
        </Link>

        <NotificationPanelButton
          className="MainMenu__NotificationButton"
          {...props.noteState}
          onClick={props.onCloseMenu}
        />

        <Link
          className="MainMenu__settings"
          to={settingsStates.settings}
          navState={props.navState}
          onClick={props.onCloseMenu}
        >
          <div className="MainMenu__settings__title">
            <span>
              {props.settingsLabel}
            </span>
          </div>
        </Link>
      </div>
    </div>
  );
}

function renderLink(data) {
  const {
    props,
    className,
    contentClassName,
    label,
    svgIcon,
    icon,
    to,
    activeStateName,
  } = data;
  return (
    <Link
      className={className}
      title={label}
      navState={props.navState}
      onClick={props.onCloseMenu}
      to={to}
      activeStateName={activeStateName}
      activeClassName="MainMenu__nav_current"
    >
      <div className={contentClassName || 'MainMenu__nav__content'}>
        {svgIcon && (
          <SvgIcon
            className="MainMenu__svgIcon"
            icon={svgIcon}
          />
        )}
        {icon && <i className={icon} />}

        <span>
          {label}
        </span>
      </div>
    </Link>
  );
}

function renderRecentList(props, className, list, selectFn) {
  return list.map(item => (
    <Link
      key={item.id}
      className={classNames(className, 'MainMenu__nav_recent')}
      navState={props.navState}

      bindParam={item}
      onClick={selectFn}
      title={item.label}
    >
      <div className="MainMenu__nav__content">
        <span>
          {item.label}
        </span>
      </div>
    </Link>
  ));
}

BaseMainMenuView.propTypes = {
  className: T.string,

  navState: T.object.isRequired,
  modelState: T.object.isRequired,
  noteState: T.object.isRequired,
  menuTimerProps: T.object.isRequired,
  latestProjects: T.array,
  latestAssets: T.array,

  avatar: T.element.isRequired,

  onSelectProject: T.func,
  onSelectAsset: T.func,
  onShowUserMenu: T.func,
  onCloseMenu: T.func,

  userSectionLabel: T.string,
  userHomeLabel: T.string,
  conversationsLabel: T.string,
  activityFeedLabel: T.string,
  navigateToLabel: T.string,
  orgHeaderLabel: T.string,
  personnelHomeLabel: T.string,
  orgCalendarLabel: T.string,
  formsLabel: T.string,
  projectsHeaderLabel: T.string,
  projectHomeLabel: T.string,
  projectRecentLabel: T.string,
  assetsHeaderLabel: T.string,
  assetsHomeLabel: T.string,
  assetsRecentLabel: T.string,
  settingsLabel: T.string,
};

BaseMainMenuView.defaultProps = {
  latestProjects: [],
  latestAssets: [],
};

export const MainMenuView = screenHeight(I18nComponent(BaseMainMenuView, [
  {code: 'mainmenu.usersection.label', prop: 'userSectionLabel'},
  {code: 'mainmenu.home.label', prop: 'userHomeLabel'},
  {code: 'mainmenu.conversations.label', prop: 'conversationsLabel'},
  {code: 'mainmenu.activityfeed.label', prop: 'activityFeedLabel'},
  {code: 'mainmenu.navigateto.label', prop: 'navigateToLabel'},
  {code: 'mainmenu.organizations.header.label', prop: 'orgHeaderLabel'},
  {code: 'mainmenu.personnel.home.label', prop: 'personnelHomeLabel'},
  {code: 'mainmenu.organizations.calendar.label', prop: 'orgCalendarLabel'},
  {code: 'mainmenu.forms.label', prop: 'formsLabel'},
  {code: 'mainmenu.projects.header.label', prop: 'projectsHeaderLabel'},
  {code: 'mainmenu.projects.home.label', prop: 'projectHomeLabel'},
  {code: 'mainmenu.projects.recent.label', prop: 'projectRecentLabel'},
  {code: 'mainmenu.assets.header.label', prop: 'assetsHeaderLabel'},
  {code: 'mainmenu.assets.home.label', prop: 'assetsHomeLabel'},
  {code: 'mainmenu.assets.recent.label', prop: 'assetsRecentLabel'},
  {code: 'mainmenu.settings.label', prop: 'settingsLabel'},
]));

MainMenuView.AvatarStyleProps = {
  className: 'MainMenu__header__avatar',
  iconClass: 'MainMenu__header__avatarIcon',
  targetWidth: 24,
  targetHeight: 24,
  cropTarget: true,
};



// WEBPACK FOOTER //
// ./src/js/app/components/MainMenu/MainMenuView.js